// i18n area 'system' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.hu-HU.meta.json.
import type { enUS } from './system'

export const huHU: typeof enUS = {
  diagnostics: {
    title: 'Diagnosztika',
    subtitle: 'Mi a baj, a legrosszabb elöl — ugyanaz a lencse, mint a tvirt diagnose',
    reload: 'Újratöltés',
    loadError: 'A diagnózist nem sikerült beolvasni',
    exportBundle: 'Csomag exportálása',
    exportError: 'A csomagot nem sikerült létrehozni',
    noProblem: 'Nincs probléma az átvizsgált területeken',
    nothingInspected: 'SEMMI sem lett átvizsgálva — ez nem egészségügyi bizonyítvány',
    inspected: 'Átvizsgálva',
    notInspected: 'NEM vizsgálva',
    localHint: 'A csomópont helyi területei (systemd unitok, journal) csak a CLI-ből olvashatók: tvirt diagnose --area local — az út, amikor az API nem válaszol.',
    thresholds: 'sikertelen feladatok {hours} órán belül, heartbeat késése {seconds} s felett',
    severity: {
      critical: 'Kritikus',
      warning: 'Figyelmeztetés',
      unknown: 'Ismeretlen'
    }
  },
  explorer: {
    title: 'Erőforrások tallózása',
    root: 'Gyökér',
    empty: 'Nincs erőforrás ebben a scope-ban',
    previewHint: 'Válassz ki egy objektumot az előnézetéhez',
    open: 'Megnyitás',

    // Il deep-link ?scope= delle liste CRUD (round #109), dall'esplora (#143).
    openScoped: 'A lista megnyitása ebben a scope-ban',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-sablon',
      ct: 'CT',
      ctTemplate: 'CT-sablon',
      app: 'App',
      overlayNetwork: 'Overlay-hálózat',
      networkService: 'Hálózati szolgáltatás',
      fabric: 'Fabric',
      subnet: 'Alhálózat',
      storage: 'Tárolókészlet',
      disk: 'Lemez',
      catalogFile: 'Katalógusfájl',
      ociRegistry: 'OCI-registry',
      ociImage: 'OCI-image',
      cephCluster: 'Ceph-klaszter',
      backupDestination: 'Backup-célhely',
      user: 'Felhasználó',
      group: 'Csoport',
      role: 'Szerepkör',
      credential: 'Hitelesítő adat',
      tag: 'Címke',
      proximityRule: 'Proximity-szabály'
    }
  },
  tags: {
    title: 'Címkék',
    empty: 'Nincs címke',
    add: 'Címke hozzáadása',
    remove: 'Eltávolítás',
    name: 'Címke',
    value: 'Érték',
    save: 'Mentés',
    saveError: 'A címkéket nem sikerült menteni',
    loadError: 'A címkeszókincs nem tölthető be',
    noVocabulary: 'Ehhez az erőforrástípushoz nincs elérhető címke',

    // A single-valued tag already set answers 409: the replacement is always
    // explicit — never an implicit substitution (design, ratified 2026-07-27).
    overwrite: 'A jelenlegi érték lecserélése',

    // Sistema > Tag, the vocabulary surface.
    createTitle: 'Címke létrehozása',
    editTitle: 'Címke szerkesztése',
    nameHint: 'Betűk, számjegyek, pontok, kötőjelek és aláhúzások — se „:”, se „/”; a tvirt- prefix a platformnak van fenntartva',
    cardinality: 'Kardinalitás',
    cardinalitySingle: 'Egyetlen érték',
    cardinalityMultiple: 'Több érték',
    cardinalityHint: 'Egyetlen értéknél a címke újra-hozzárendelése a lecserélését kéri',
    autoCreate: 'Értékek auto-létrehozása',
    autoCreateOn: 'Hozzárendeléskor',
    autoCreateOff: 'Csak deklaráltak',
    autoCreateHint: 'Bekapcsolva: egy új érték hozzárendelése létrehozza. Kikapcsolva: csak a deklarált értékek rendelhetők hozzá',
    values: 'Értékek',
    noValues: 'Nincs deklarált érték',
    addValue: 'Érték hozzáadása',
    duplicateValue: 'Duplikált érték',
    kinds: 'Erőforrástípusok',
    kindsAll: 'Mind',
    kindsPlaceholder: 'Mind',
    kindsHint: 'Hagyd üresen, hogy minden címkézhető erőforrástípust megengedj',
    systemChip: 'Rendszer',
    deleteCascade: 'A hozzárendelések eltávolítása is',
    deleteCascadeHint: 'Egy még valamely erőforráshoz rendelt címke elutasításra kerül: ezzel a beállítással az értékek és az összes hozzárendelés a címkével együtt távozik.'
  },
  scopes: {
    title: 'Scope-ok',
    createTitle: 'Scope létrehozása',
    editTitle: 'Scope átnevezése',
    path: 'Útvonal',
    segment: 'Szegmens',
    segmentHint: 'Kisbetűk, számjegyek és kötőjelek (DNS-1123)',
    parent: 'Szülő',
    rootChip: 'Gyökér',
    preview: 'Új scope',
    pickLabel: 'Scope',
    pickHint: 'Hol él az objektum a klaszter fájában — a gyökérben vagy egy azon belüli vDC-ben.',
    ociCache: 'OCI-gyorsítótár (felülbírálás)',
    appEphemeral: 'Efemer App-készletek (felülbírálás)',
    inherit: 'Öröklés',
    inheritsFrom: 'Innen örökli:',
    inheritsCluster: 'A klaszter defaultjának öröklése',
    inheritsNone: 'Öröklés — nincs tényleges készlet',
    failoverProtection: 'Védelem degradált állapotban',
    networkWeight: 'Hálózati súly',
    networkCeil: 'Hálózati felső korlát (Mbps)',
    protectionProtected: 'Védett',
    protectionExpendable: 'Degradáltan feláldozható',
    protectionDefault: 'A klaszter defaultja'
  },

  // Sistema > Informazioni (round #124, 2026-07-31): versioni piattaforma
  // nella flotta (al massimo due mid-upgrade), componenti per nodo, manuale
  // PDF servito localmente e card licenza inglobata.
  sysinfo: {
    summary: 'A platform verziói a klaszterben, az egyes csomópontok komponensei, az adminisztrációs kézikönyv és a licenc.',
    platformTitle: 'TVirt platform',
    platformSubtitle: 'A klaszter csomópontjain megfigyelt verziók',
    versionOnNodes: '{version} — {n} csomóponton',
    versionOnOneNode: '{version} — 1 csomóponton',
    mixedVersions: 'Egynél több platformverzió van a klaszterben — csak folyamatban lévő frissítés alatt várható (legfeljebb kettő).',
    tooManyVersions: 'Kettőnél több platformverzió van a klaszterben — ez sosem várható, még frissítés alatt sem: ellenőrizd a lenti csomópontokat.',
    unreportedNodes: 'Még nincs verziójelentés innen: {nodes}',
    noVersionsYet: 'Még egyetlen csomópont sem jelentette a verzióit.',
    nodesUnavailable: 'A csomópontok listája a jogosultságaiddal nem látható — a platform verziói nem jeleníthetők meg.',
    colNode: 'Csomópont',
    manualTitle: 'Adminisztrációs kézikönyv',
    manualSubtitle: 'Helyi másolat, ez a klaszter szolgálja ki',
    manualBody: 'A teljes TVirt-kézikönyv PDF-ben, közvetlenül a platformról kiszolgálva — air-gapped környezetekben is elérhető.',
    manualLink: 'Adminisztrációs kézikönyv (PDF)',
    apiExplorerTitle: 'API-böngésző',
    apiExplorerSubtitle: 'Az OpenAPI-kontraktus, böngészhető',
    apiExplorerBody: 'A platform teljes OpenAPI-kontraktusa — minden útvonal, séma és válaszkód — böngészhető a böngészőből, ezen a csomóponton keresztül kiszolgálva.',
    apiExplorerLink: 'API felfedezése',
    kubeTitle: 'Kubernetes-kompatibilitás',
    kubeSubtitle: 'kubectl és eszközei a natív API előtt',
    kubeBody: 'A TVirt KubeCompat a Podokat, Deploymenteket, Service-eket, névtereket, csomópontokat és eseményeket vetíti Kubernetes-dialektusba — csak olvasásra, plusz a Deploymentek törlése. Minden hívás a natív API-n megy át a te jogosultságaiddal: a kubeconfigban app tokent használj bearerként.',
    kubeEndpoint: 'Endpoint a kubectl számára',
    kubeStatusActive: 'Aktív — Kubernetes {version}',
    kubeStatusMissing: 'Nincs telepítve ezen a csomóponton (trantor-tvirt-kubecompat csomag)',
    kubeStatusDown: 'Telepítve, de nem válaszol — ellenőrizd a trantor-tvirt-kubecompat unitot',
    kubeStatusChecking: 'Ellenőrzés…'
  },

  // Licensing (round 2026-07-29): la pagina della licenza a sottoscrizione.
  licensing: {
    title: 'A klaszter licence',
    subtitle: 'Előfizetéses licenc — klaszterenként legfeljebb egy',
    absentTitle: 'Nincs regisztrált licenc',
    absentBody:
      'Érvényes licenc nélkül a klaszter megtagadja az új virtuális gépek indítását (a bekapcsolt VM-ek bekapcsolva maradnak). Regisztráld az előfizetéssel kapott termékkulcsot.',
    registerButton: 'Licenc regisztrálása',
    removeButton: 'Licenc eltávolítása',
    state: {
      ok: 'Érvényes',
      limitExceeded: 'Korlát túllépve',
      expired: 'Lejárt'
    },
    productKeyLabel: 'Termékkulcs',
    basisLabel: 'A korlát alapja',
    basis: {
      concurrentVms: 'Egyszerre bekapcsolt VM-ek',
      physicalCores: 'Fizikai magok (a klaszter összesen)'
    },
    limitLabel: 'Korlát',
    usageLabel: 'Jelenlegi használat',
    usageOf: '{used} / {limit}',
    usagePartial: 'részleges összeg — {n} csomópont megfigyelt CPU-topológia nélkül',
    usageUnknown: 'jelenleg nem megfigyelhető',
    expiresLabel: 'Lejárat',
    neverExpires: 'soha',
    registeredLabel: 'Regisztrálva',
    gateNote:
      'Hiányzó, lejárt vagy korláton túli licenccel a klaszter megtagadja az ÚJ virtuális gépek indítását. A bekapcsolt VM-ek bekapcsolva maradnak, és a HA-újraindításokat nem érinti.',
    devStage:
      'Fejlesztési fázis: a termékkulcs úgy, ahogy van, elfogadásra kerül az itt deklarált korlátokkal együtt; az aláírt kulcsos validálás egy jövőbeli kiadással érkezik.',
    dialogTitle: 'Licenc regisztrálása',
    dialogExpiresHelp: 'Üresen = a licenc sosem jár le',
    dialogSubmit: 'Regisztrálás',
    dialogError: 'A licencet nem sikerült regisztrálni.',
    removeTitle: 'Licenc eltávolítása',
    removeBody:
      'A klaszter LICENC NÉLKÜL marad: az új virtuális gépek megtagadják az indulást, amíg nem regisztrálsz egyet. A bekapcsolt VM-ek bekapcsolva maradnak.',
    removeConfirm: 'Eltávolítás',
    removeError: 'A licencet nem sikerült eltávolítani.'
  },
  rbac: {
    tabRoles: 'Szerepkörök',
    tabGrants: 'Delegálások',
    rolesTitle: 'Szerepkörök',
    createRoleTitle: 'Szerepkör létrehozása',
    editRoleTitle: 'Szerepkör szerkesztése',
    nameHint: 'Kisbetűk, számjegyek és kötőjelek; a tvirt- prefix fenntartott',
    systemChip: 'Rendszer',
    permissions: 'Engedélyek',
    permissionsPlaceholder: 'Engedély hozzáadása…',
    includedRoles: 'Tartalmazott szerepkörök',
    includedRolesPlaceholder: 'Szerepkör hozzáadása…',
    grantsTitle: 'Delegálások',
    createGrantTitle: 'Delegálás létrehozása',
    principal: 'Principal',
    principalKind: 'Principal típusa',
    principalUser: 'Felhasználó',
    principalGroup: 'Csoport',
    role: 'Szerepkör',
    grantRight: 'Delegálás',
    grantRightChip: 'Delegálhat',
    grantRightLabel: 'Delegálási joggal (a címzett maga is delegálhatja ezt a szerepkört)',
    effective: 'Hatályos',
    notEffective: 'Nem hatályos',
    createdAt: 'Létrehozva',
    scopeHint: '/path pontos, /path/* rekurzív — a delegálások egy csatolt gyökérhez horgonyzódnak (/* nem delegálható)'
  },
  groups: {
    title: 'Csoportok',
    createTitle: 'Csoport létrehozása',
    nameHint: 'Kisbetűk, számjegyek és kötőjelek; a scope-on belül egyedi',
    members: 'Tagok',
    membersTitle: 'Tagok',
    membersPlaceholder: 'Felhasználó hozzáadása…',
    noMembers: 'Nincs tag',
    realmMappings: 'Realm-leképezések',
    realmMappingsTitle: 'Realm-leképezések',
    realmMappingsHint:
      'Minek felel meg ez a csoport az egyes külső realmekben. A tagság a bejelentkezés pillanatában olvasódik a címtárból: az a címtárcsoport, amelyet itt senki sem képez le, figyelmen kívül marad, és a beágyazás nem oldódik fel — a címtár oldalán kell laposítani.',
    realm: 'Realm',
    externalGroup: 'Külső csoport',
    addRealmMapping: 'Leképezés hozzáadása',
    removeRealmMapping: 'Leképezés eltávolítása',
    noRealmMappings: 'Nincs realm-leképezés',

    // Dialog di creazione a sezioni (round realm-wizard, 2026-08-03): Generale
    // più la superficie di mappatura coi realm esterni, con l'empty state
    // parlante.
    sectionGeneral: 'Általános',
    mappingsNoRealms: 'Nincs konfigurált külső realm — a leképezési felület megnyílik, amint létezik egy realm.',
    mappingsNoRealmsLink: 'A Realmek és SSO lap megnyitása',

    // L'obbligo MFA imposto dal gruppo (round #178 metà B): OR puro — un
    // gruppo può solo AGGIUNGERE l'obbligo, mai toglierlo.
    mfaRequired: 'MFA-kötelezettség',
    mfaRequiredChip: 'MFA-t követel',
    mfaNotRequiredChip: 'Nincs kötelezettség',
    mfaRequiredHint:
      'Tiszta VAGY: egy csoport csak HOZZÁADHATJA a második faktor kötelezettségét a tagjainak — a külső identitásoknak is, realm-leképezéseken keresztül —, elvenni sosem tudja. A következő bejelentkezéstől érvényes: a nyitott munkamenetek nem záródnak be.'
  },
  users: {
    title: 'Felhasználók',
    createTitle: 'Felhasználó létrehozása',
    editTitle: 'Felhasználó szerkesztése',
    username: 'Felhasználónév',
    usernameHint: 'Kisbetűk, számjegyek, pontok és kötőjelek',
    displayName: 'Megjelenített név',
    enabled: 'Engedélyezve',
    state: 'Állapot',
    enabledChip: 'Engedélyezve',
    disabledChip: 'Letiltva',
    lockedChip: 'Zárolva',
    password: 'Jelszó',
    passwordSetChip: 'Beállítva',
    mustChangeChip: 'Cserélendő',
    initialPassword: 'Kezdeti jelszó',
    initialPasswordHint: 'A felhasználónak az első bejelentkezéskor meg kell változtatnia',
    lastLogin: 'Utolsó bejelentkezés',
    neverLoggedIn: 'Sosem lépett be',
    setPasswordTitle: 'Jelszó beállítása',
    setPasswordHint: 'Adminisztratív csere — a te jelszavadat kéri (sudo mód), és a felhasználót a következő bejelentkezéskor a megváltoztatására kötelezi.',
    operatorPassword: 'A te jelszavad',
    unlock: 'A fiók feloldása',
    revokeTitle: 'Munkamenetek visszavonása',
    revokeBody: 'A felhasználó összes aktív munkamenete azonnal megszűnik.',
    revokeIncludeTokens: 'Az app tokenek visszavonása is',
    revokeConfirm: 'Visszavonás',

    // Dialog standard (round #156): dettagli completi, tab account/sicurezza.
    tabAccount: 'Fiók',
    tabSecurity: 'Biztonság',
    usernameImmutableHint: 'A felhasználónév a fiók identitása — a létrehozáskor rögzül',
    groups: 'Csoportok',
    noGroups: 'Nincs csoport',
    mustChangePassword: 'Kötelező jelszócsere',
    failedAttempts: 'Sikertelen bejelentkezési kísérletek',
    lockedUntil: 'Zárolva eddig:',

    // Identity tabs (2026-08-03): Sistema > Utenti è diventata una sezione a
    // tab sul modello di /system/rbac — utenti, gruppi, realm esterni.
    tabUsers: 'Felhasználók',
    tabGroups: 'Csoportok',
    tabRealms: 'Realmek és SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178): la vista del secondo fattore. Metà A — la tabella
    // per-utente su users.yaml; metà B (round contract, ratifiche 2026-08-04)
    // — il verdetto efficace con la provenienza, gli enrollment esterni con
    // lo stato orfano e i gruppi che impongono l'obbligo.
    mfa: {
      title: 'Második faktor (MFA)',
      methodsTitle: 'Elérhető módszerek',
      methodsSubtitle: 'Amit ez az installáció második faktorként ellenőrizni tud',
      methodsError: 'A módszerek nyilvántartása nem tölthető be',
      builtinChip: 'Beépített',
      enrollableChip: 'Enrollment a TVirt-ben',
      delegatedChip: 'Külsőleg kezelt',
      state: 'Állapot',
      stateActive: 'Aktív',
      statePending: 'Enrollmentre vár',
      stateNone: 'Nincs enrollment',
      required: 'MFA-kötelezettség',
      requiredChip: 'Kötelező',
      notRequiredChip: 'Nem kötelező',
      enrolledAt: 'Enrollment dátuma',
      enrolledMethods: 'Regisztrált módszerek',
      noMethods: 'Nincs enrollment',
      codesRemaining: 'Hátralévő helyreállítási kódok',
      resetTitle: 'A második faktor nullázása',
      resetHint:
        'Az enrollment és az összes helyreállítási kód nullázódik: a következő bejelentkezéskor a felhasználó elölről csinálja az enrollmentet. Az MFA-kötelezettség marad, ahogy van — egy adminisztrátor sosem állít be titkot, csak nullázza.',
      resetConfirm: 'Nullázás',
      resetError: 'A második faktort nem sikerült nullázni',
      empty: 'Még nincs kezelt felhasználó — a fiókok itt jelennek meg, amint léteznek, mindegyik a saját második-faktor állapotával.',

      // Metà B (round #178): provenienza del verdetto efficace, enrollment
      // esterni con lo stato orfano, gruppi che impongono l'obbligo.
      viaSelf: 'Személyes',
      viaSelfHint: 'A fiók személyes hozzájárulása (a saját flagje) — az egyetlen rész, amelyet a ceruza módosít.',
      viaGroupHint: 'Ettől a csoporttól örökölt kötelezettség: a személyes flag levétele nem szabadítja fel a felhasználót — a csoportnál kell beavatkozni, a Csoportok lapon.',
      subject: 'Identitás',
      lastSeenAt: 'Utolsó megerősítés',
      enrollmentPending: 'Függőben',
      orphanChip: 'Árva',
      orphanDirectoryMiss: 'Az identitás már nincs a címtárban',
      orphanRealmRemoved: 'A realm el lett távolítva a TVirt-ből',
      orphanedAt: 'Árva ez óta:',
      directoryUuid: 'UUID a címtárban',
      externalTitle: 'Külső enrollmentek',
      externalEmpty: 'Még nincs külső enrollment — egy MFA-köteles címtáridentitás első bejelentkezésekor születik.',
      orphanHelp:
        'Egy árva enrollment sosem törlődik magától: biztonsági anyag — megmarad az auditnak, és ha az identitás újra felbukkan a címtárban, visszakapja a faktorát. Az egyetlen kiút az adminisztratív nullázás.',
      visibilityHint: 'A külső enrollmentek a klaszter gyökerében laknak: csak az látja őket, akinek user.read joga van a teljes fára.',
      orphanResetHint:
        'Az árva sor végleg törlődik: többé senki sem tart rá igényt. Ha az identitás újra megjelenik a címtárban, elölről csinálja az enrollmentet.',
      enforcingTitle: 'MFA-t követelő csoportok',
      enforcingSubtitle:
        'A külső identitások kötelezettségének horgonya a csoport: a realm-leképezései mondják meg, melyik címtárpopulációhoz ér el. A külső enrollment a kötelezett felhasználó első bejelentkezésekor születik.',
      enforcingEmpty: 'Egyetlen csoport sem követel MFA-t — a kötelezettség a csoporton kapcsolható be, a Csoportok lapról.',
      enforcingError: 'Az MFA-t követelő csoportok nem tölthetők be'
    }
  },
  realms: {
    title: 'Hitelesítési realmek',
    createTitle: 'Realm létrehozása',
    editTitle: 'Realm szerkesztése',
    name: 'Realm',
    nameHint: 'A domain, amelyet a felhasználók a @ után írnak (example.com) — a létrehozás után nem módosítható',
    nameImmutableHint: 'A realm neve minden munkamenetbe és minden auditsorba bele van nyomtatva, amely valaha megnevezte — az átnevezése átírná a történelmet',
    kind: 'Típus',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'Az OIDC és a SAML a következő körökkel érkezik — ma egy realm egy LDAPv3-címtár',

    // Semi-wizard di creazione (round realm-wizard, 2026-08-03): le card dei
    // tipi del passo 1 — ldap vivo, oidc/saml card in roadmap (mai un form
    // senza un backend dietro).
    kindCategory: 'A realm típusa',
    kindSelectHint: 'Válaszd ki a címtár típusát, amelyen ez a realm hitelesíteni fog.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Felhasználónév és jelszó egy LDAPv3-címtáron végzett binddal ellenőrizve — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Böngészős single sign-on egy OpenID Connect identity providerre delegálva — a következő körökkel érkezik.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Vállalati single sign-on SAML 2.0 assertionökkel — a következő körökkel érkezik.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Engedélyezve',
    urls: 'Címtárszerverek',
    urlsHint: 'Soronként egy ldap:// vagy ldaps:// URL (1–8), sorrendben próbálva — failover, sosem terheléselosztás',
    startTls: 'StartTLS',
    verifyCertificate: 'A tanúsítvány ellenőrzése',
    cleartextWarning: 'ldaps:// vagy StartTLS nélkül a bind-jelszó nyílt szövegként megy át a hálózaton — laborban elfogadható, éles környezetben soha.',
    noVerifyWarning: 'Egy nem ellenőrzött TLS-munkamenet senkit sem hitelesít: az ellenőrzést csak olyan címtár felé kapcsold ki, amelyet nem tudsz megjavítani.',
    caCertificate: 'CA-tanúsítvány (PEM)',
    caCertificateHint: 'Opcionális CA-bundle, e realm TLS/StartTLS-handshake-jéhez rögzítve; üresen eltávolítja',
    caCertificatePinned: 'Rögzítve',
    connectTimeout: 'Időkorlát (másodperc)',
    connectTimeoutHint: 'URL-enkénti kapcsolódási és kérési határidő (1–60); lejártakor a következő URL-lel próbálkozik',
    bindDn: 'Bind DN',
    bindDnHint: 'A service account, amely a felhasználó keresését végzi; üresen = anonim search bind (az AD elutasítja)',
    anonymousBind: 'Anonim search bind',
    bindCredential: 'Bind-jelszó (keystore)',
    bindCredentialHint: 'Egy usernamePassword keystore-bejegyzés a bind-jelszóval — a titok sosem él a realmen',
    bindCredentialNone: 'Nincs (anonim bind)',
    bindCredentialEmpty: 'Nincs usernamePassword bejegyzés a keystore-ban — hozz létre egyet a Rendszer > Hitelesítő adatok alatt a bind-jelszónak.',
    baseDn: 'Base DN',
    baseDnHint: 'A részfa, ahonnan a felhasználó keresése indul (DC=example,DC=com)',
    userFilter: 'Felhasználószűrő',
    userFilterHint: 'A %u a login lokális részével helyettesítődik, RFC 4515 escape-pel; a nem-AD címtárak jellemzően ezt kérik: (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf attribútum',
    memberOfAttributeHint: 'Egyetlen egyszer olvasódik, a bejelentkezéskor — a nem leképezett csoportok figyelmen kívül maradnak, a beágyazás nem oldódik fel',
    uuidAttribute: 'UUID attribútum',
    uuidAttributeHint: 'A realmen belüli megváltoztathatatlan UUID (AD-n objectGUID, OpenLDAP-on entryUUID) — az auditba nyomtatva a felhasználó@realm mellé',
    displayNameAttribute: 'Megjelenített név attribútum',
    displayNameAttributeHint: 'A felhasználó köszöntésére szolgál; hiányában a bejelentkezési név használatos',
    sudoHint: 'A realmekre való írás sudo-védett: egy realm egy bejárati kapu a platformra',
    deleteBody: 'A realm csoportleképezései vele együtt távoznak; az általa hitelesített munkamenetek a lejáratukig élnek — egy törölt realm egyszerűen nem enged be többé senkit.',
    tabConnection: 'Kapcsolat',
    tabDirectory: 'Címtár',
    testTitle: 'Kapcsolat tesztelése',
    testHint: 'Konfigurációs szonda, sosem hitelesítés: kapcsolódik, bindol a service accounttal, és — felhasználónévvel — lefuttatja a felhasználószűrőt.',
    testUsername: 'Felhasználónév (opcionális)',
    testUsernameHint: 'Egy lokális rész, amelyen a felhasználószűrő lefut — 1 találat az egészséges válasz',
    testRun: 'Teszt futtatása',
    testError: 'A szondát nem sikerült lefuttatni',
    testReachable: 'A címtár elérhető, a szolgáltatási bind elfogadva',
    testUnreachable: 'A címtár NEM érhető el',
    matchedOne: 'A felhasználószűrő pontosan 1 bejegyzést talált — az egészséges válasz.',
    matchedNone: 'A felhasználószűrő egyetlen bejegyzést sem talált: a szűrő vagy a base DN hibás.',
    matchedMany: 'A felhasználószűrő {count} bejegyzést talált: nem szelektív, és a bejelentkezések kétértelműek lennének (elutasítva).',
    mappingsPointer: 'Hogy egy külső csoport minek felel meg, az a TVirt-csoport tulajdonsága (a realm-leképezései): az igazság pontja a Csoportok lapon él.',
    mappingsPointerLink: 'A Csoportok lap megnyitása',
    rootHomeHint: 'Egy külső realm identitásai a klaszter gyökerében élnek, sosem egy vDC-ben: az engedélyeket ott adod, ahol kellenek, delegálásokkal — a csoporton vagy közvetlenül a felhasználón, pontosan mint a natívoknál.'
  },
  credentials: {
    title: 'Hitelesítő adatok',
    createTitle: 'Hitelesítő adat létrehozása',
    editTitle: 'Hitelesítő adat szerkesztése',
    kind: 'Típus',
    kindUsernamePassword: 'Felhasználónév és jelszó',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-identitás)',
    kindHintUsernamePassword: 'Nem módosítható. A CIFS/SMB-tárolókhoz — a csatolási fiók, amelynek titkát a worker a csatolás pillanatában használja.',
    kindHintIscsiChap: 'Nem módosítható. Az iSCSI CHAP-hitelesítéshez — felhasználónév = CHAP-név, titok = CHAP-titok.',
    kindHintNvmeDhchap: 'Nem módosítható. Az NVMe over Fabrics DH-HMAC-CHAP-jához — titok = a DHHC-1:xx:… blob; a felhasználónév csak egy címke.',
    kindHintCephx: 'Nem módosítható. A Ceph-klienseknek — felhasználónév = kliensnév (client.…), titok = a base64 kulcs.',
    kindImmutableHint: 'A típus a létrehozás után nem módosítható — a megváltoztatása új hitelesítő adatot jelent.',
    username: 'Felhasználónév',
    usernameChap: 'CHAP-név',
    usernameNvme: 'Címke',
    usernameCephx: 'Kliensnév',
    usernameHint: 'Opcionális fiók, amelyhez a titok tartozik',
    usernameHintChap: 'A CHAP-név, amellyel az initiator hitelesíti magát',
    usernameHintNvme: 'Az átvitel nem használja — szabad címke a jegyzeteidnek',
    usernameHintCephx: 'A cephx-kliens neve — a client. prefix tolerálva',
    secret: 'Titok',
    secretHint: 'Csak írható: a fogyasztók használják, többé nem jelenik meg.',
    secretHintNvmeDhchap: 'Csak írható: a host DH-HMAC-CHAP titka a kanonikus DHHC-1:xx:… alakban — a fogyasztók használják, többé nem jelenik meg.',
    secretHintCephx: 'Csak írható: a base64 cephx-kulcs — a fogyasztók használják, többé nem jelenik meg.',
    secretEditHint: 'Hagyd üresen, ha nem változtatod a titkot — kitöltése rotálja.',
    createdAt: 'Létrehozva',
    inUseError: "A(z) '{name}' adatra egy tároló konfigurációja hivatkozik — előbb ott válaszd le.",
    nameHint: 'Kisbetűk, számjegyek és kötőjelek (DNS-1123); a scope-on belül egyedi',

    // Dialog di sola rotazione (round #156): il segreto non ha mai la matita inline.
    rotateTitle: 'Titok rotálása',
    rotateHint: 'Csak írható: az új titok lecseréli a tároltat — a fogyasztók a következő csatoláskor használják.',

    // Round #159 (PKI): i tab Certificati e CA.
    tabSecrets: 'Titkok',
    tabCertificates: 'Tanúsítványok',
    tabAuthorities: 'Hitelesítésszolgáltatók',
    certificatesTitle: 'Tanúsítványok',
    authoritiesTitle: 'Hitelesítésszolgáltatók',
    caCreateTitle: 'Új CA',
    certCreateTitle: 'Új tanúsítvány',
    caMode: 'Eredet',
    caModeGenerate: 'Generálás a TVirt-tel',
    caModeImport: 'Importálás (kulcs + tanúsítvány)',
    certMode: 'Eredet',
    certModeIssue: 'Kibocsátás egy keystore-beli CA-tól',
    certModeImport: 'Importálás (kulcs + tanúsítvány)',
    issuingCa: 'Kibocsátó CA',
    issuingCaHint: 'A tanúsítvány a CA scope-jában születik, regisztrált parenttel',
    noCasHint: 'Nincs CA a keystore-ban — előbb generálj vagy importálj egyet a CA lapon',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'A CA subjectje: betűk, számjegyek, szóköz, pont, aláhúzás, kötőjel',
    commonNameCertHint: 'Az OpenVPN a CN-ből azonosítja a klienseket — tartsd CA-nként egyedinek',
    days: 'Érvényesség (nap)',
    daysCaHint: '1–7300 nap; 3650 (10 év) a default',
    daysCertHint: '1–3650 nap; 365 a default',
    keyType: 'Kulcstípus',
    keyTypeHint: 'Az EC P-256 a default; RSA a legacy fogyasztóknak',
    usage: 'Használat',
    usageClient: 'Kliens (clientAuth)',
    usageServer: 'Szerver (serverAuth)',
    usageHint: 'Az extended key usage, amelyre a tanúsítvány kibocsátásra kerül',
    san: 'Alternatív nevek (SAN)',
    sanHint: 'Vesszővel elválasztva; a literális IP-kből IP: bejegyzés lesz, a többiből DNS:',
    keyPem: 'Privát kulcs (PEM)',
    keyPemHint: 'Csak írható: a keystore őrzi, többé nem jelenik meg',
    certPem: 'Tanúsítvány (PEM)',
    certPemHint: 'A kulcshoz párosuló nyilvános tanúsítvány',
    certPemCaHint: 'A kulcshoz párosuló CA-tanúsítvány (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Kibocsátó',
    parentCa: 'Kibocsátó CA',
    parentCaImported: 'Importált — a TVirt-en kívül kibocsátva',
    serial: 'Sorozatszám',
    fingerprint: 'Ujjlenyomat (SHA-256)',
    validFrom: 'Érvényes ettől:',
    validUntil: 'Érvényes eddig:',
    expiry: 'Lejárat',
    expired: 'Lejárt',
    expiresInDays: '{days} nap múlva jár le',
    revoked: 'Visszavonva',
    revokedAtLabel: 'Visszavonva ekkor:',
    revokeTitle: 'Tanúsítvány visszavonása',
    revokeAction: 'Visszavonás',
    revokeWarning: 'A visszavonás végleges: a sorozatszám bekerül a kibocsátó CA CRL-jébe, és minden fogyasztó, amely elutasítja a visszavont tanúsítványokat (elsősorban az OpenVPN), ezt is vissza fogja dobni. Un-revoke nem létezik.',
    exportPem: 'PEM exportálása',
    exportChain: 'Lánc-bundle exportálása',
    exportCrl: 'CRL exportálása',
    materialImmutableHint: 'Az X.509-anyag nem módosítható — bocsásd ki vagy importáld újra',
    caInUseError: "A(z) '{name}' CA-nak még vannak élő kibocsátott tanúsítványai (vagy egy tároló hivatkozik rá) — előbb vond vissza vagy töröld őket."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Elhelyezés, rendelkezésre állás és affinitás — hol futnak a klaszter VM-jei, és be kell-e kapcsolva lenniük',
    loadError: 'A Proximity-panelhez a klaszter store-ja kell — a flotta állapota most nem érhető el',
    config: {
      title: 'Konfiguráció',
      subtitle: 'Klaszterszintű elhelyezési politika',
      save: 'Mentés',
      saveError: 'A konfiguráció el lett utasítva',
      strategy: 'Kiválasztási stratégia',
      strategy_leastUsedResources: 'Legkevesebb használt erőforrás',
      strategy_leastVms: 'Legkevesebb VM',
      strategy_random: 'Véletlenszerű',
      strategyLeastUsedResourcesHint: 'Az érvényes jelöltek közül a legtöbb maradék használható RAM-mal rendelkező csomópont (megfigyelt összes − host-tartalék − bekapcsolt VM-ek), vCPU-kötelezettség döntetlen esetén. Azonos adatoknál determinisztikus.',
      strategyLeastVmsHint: 'Az érvényes jelöltek közül a legkevesebb bekapcsolt VM-mel rendelkező csomópont; a döntetlenek név szerint dőlnek el. Azonos adatoknál determinisztikus.',
      strategyRandomHint: 'Egyenletesen véletlenszerű az érvényes jelöltek között.',
      liveness: 'A csomópontok életjel-küszöbe (másodperc)',
      livenessHint: 'A küszöbön túl hallgató tag elérhetetlen: kizárva az elhelyezésből, és — ha nincs karbantartásban — a HA-decider halottnak tekinti, elkeríti, és máshol újraindítja a HA VM-jeit.',
      decider: 'HA-decider',
      deciderNone: 'még nincs megválasztva'
    },
    nodesTitle: 'Csomópontok',
    nodesSubtitle: 'Életjel és empirikus kapacitás — használható RAM = összes − alap − lekötött',
    nodeCol: 'Csomópont',
    stateCol: 'Állapot',
    ramCol: 'RAM (összes − alap − lekötött)',
    usableCol: 'Használható',
    vmsCol: 'Terhelés',
    neverSeen: 'sosem jelentkezett',
    freshChip: 'elérhető',
    staleChip: 'elérhetetlen',
    attestedChip: 'kikapcsoltnak nyilvánítva',
    ramFormula: 'összes − alap − lekötött',
    haTitle: 'Magas rendelkezésre állás',
    haSubtitle: 'A HA-flages VM-ek „mindig bekapcsoltak”: a TVirt minden nem kért leállás után újraindítja őket — ugyanazon a csomóponton backoffal, egy másikon, amikor az övék meghal (csak megosztott tárolóval).',
    haNone: 'Egyetlen VM-nek sincs még HA-flagje — kapcsold be itt vagy a VM részleteiben.',
    haVmCol: 'Virtuális gép',
    haStateCol: 'Állapot',
    haRestartsCol: 'HA-újraindítások',
    haLastEventCol: 'Utolsó esemény',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'A HA módosítása el lett utasítva',
    rules: {
      title: 'Affinitási szabályok',
      createTitle: 'Új Proximity-szabály',
      editTitle: 'Szabály szerkesztése',
      nameHint: 'Kisbetűk, számjegyek és kötőjelek (DNS-címke)',
      vms: 'Virtuális gépek',
      vmsHint: 'Legalább két VM — a szabály azt köti meg, hol futnak egymáshoz képest',
      type: 'Típus',
      affinity: 'Affinitás (együtt)',
      antiAffinity: 'Anti-affinitás (külön)',
      typeAffinityHint: 'A VM-eknek UGYANAZON a csomóponton kell futniuk.',
      typeAntiAffinityHint: 'A VM-eknek KÜLÖNBÖZŐ csomópontokon kell futniuk — a klasszikus HA-páros.',
      mode: 'Mód',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'A megszegések beszédes hibával utasítják el a műveletet (indítás, migráció, failover).',
      modeSoftHint: 'Preferencia, sosem blokkoló: a szabályt sértő elhelyezés látható figyelmeztetéssel megy tovább.',
      satisfied: 'Elhelyezés',
      satisfiedYes: 'betartva',
      satisfiedNo: 'megsértve',

      // Dialog standard (round #156): le violazioni hanno la loro riga, non un tooltip.
      violations: 'Megszegések',
      noViolations: 'Nincs'
    },
    events: {
      title: 'HA-események',
      subtitle: 'A rendelkezésre állás naplója — újraindítások, fencing, failover és az őszinte kihagyások',
      none: 'Még semmi.',
      when: 'Mikor',
      kind: 'Esemény',
      target: 'Objektum',
      detail: 'Részlet',
      kindRestarted: 'HA-újraindítás',
      kindGaveUp: 'feladás (crash loop)',
      kindNodeAttested: 'csomópont elkerítve',
      kindFailedOver: 'failover',
      kindNoCandidate: 'nincs jelölt',
      kindStorageLocalSkip: 'kihagyva (helyi tároló)',
      kindZombieFenced: 'zombi terminálva'
    }
  }
}
